import L from 'leaflet';
import 'leaflet.geodesic';
import { sortedStops, stopLatLng } from './stop-shape';

function latLngFromSortedStop(shipment, end) {
  const stops = sortedStops(shipment?.stops);
  if (!stops.length) {
    return null;
  }
  const stop = end === 'from' ? stops[0] : stops[stops.length - 1];
  const ll = stopLatLng(stop);
  return ll ? L.latLng(ll.lat, ll.lng) : null;
}

export function getFromLatLng(shipment) {
  return latLngFromSortedStop(shipment, 'from');
}

export function getToLatLng(shipment) {
  return latLngFromSortedStop(shipment, 'to');
}

const COMPLETED_STATUSES = new Set(['Completed', 'Completed Late']);

export function createArc(shipment, options = {}) {
  if (COMPLETED_STATUSES.has(shipment.status)) return null;
  const from = getFromLatLng(shipment);
  const to = getToLatLng(shipment);
  if (!from || !to) return null;

  return new L.Geodesic([[from, to]], {
    color: '#3B82F6',
    weight: 2,
    opacity: 0.75,
    dashArray: '4 6',
    steps: 50,
    wrap: false,
    ...options,
  });
}
